<div class="web-links-container" [nbSpinner]="loading" nbSpinnerStatus="info">
  <div class="web-links-header">
    <strong>Комментарии</strong>
    <nb-icon [nbTooltip]="'Сортировка комментариев'" (click)="toggleSort()" [icon]="direct ? 'arrow-circle-down-outline' : 'arrow-circle-up-outline'"></nb-icon>
    <button nbButton size="small" (click)="toggleShowCommentForm()" style="background: #fff">Добавить комментарий</button>
  </div>

  <div class="comment-box add">
    <ng-container *ngIf="showCommentForm">
      <ng-container *ngTemplateOutlet="richEditor;context:{comment: null, formGroup: commentNewForm, control: commentNewControl}"></ng-container>
    </ng-container>
  </div>

  <ng-container *ngFor="let comment of comments">
    <div class="comment-box" *ngIf="!comment.deleted">
      <div class="avatar-box nd2">
        <app-crm-avatar [customer]="comment.author" [size]="'s'"></app-crm-avatar>
        <strong>{{ comment.author.name }}</strong>
        <small>{{ comment.createdAt | date: 'dd MMMM yyyy, HH:mm' }}</small>

        <ng-container *ngIf="editComment?.id !== comment.id">
          <nb-icon icon="edit-outline" (click)="edit(comment)"></nb-icon>
          <nb-icon icon="trash-outline" (click)="delete(comment)"></nb-icon>
        </ng-container>
      </div>
      <div class="comment-input-box">
        <ng-container *ngIf="editComment?.id !== comment.id">
          <app-rich-text [html]="comment.content"></app-rich-text>
        </ng-container>
        <ng-container *ngIf="editComment?.id === comment.id">
          <ng-container *ngTemplateOutlet="richEditor;context:{comment: comment, formGroup: commentForm, control: commentControl}"></ng-container>
        </ng-container>
      </div>
    </div>
  </ng-container>
</div>

<ng-template #richEditor let-comment="comment" let-formGroup="formGroup" let-control="control">
  <ng-container *ngIf="formGroup">
    <form [formGroup]="formGroup">
      <div class="mb-3" style="margin: 20px 0">
        <app-rich-text [control]="control" [showForm]="showCommentForm || !!editComment" (doSave)="saveComment(control, comment)" (doCancel)="cancelComment(control)"></app-rich-text>
      </div>
    </form>
  </ng-container>
</ng-template>
